import React from 'react';
import VideoCard from './VideoCard';

const VideoSection = () => {
  const videos = [
    {
      
      description: "Cada 10 minutos muere asesinada una mujer",
      videoId: "k8zzHhhpKa0", 
    },
    {
      description: "DESAPARICIONES de MUJERES en MÉXICO",
      videoId: "H89eOZ1PgF0", 
    },
    {
      description: "MADRES BUSCADORAS DOCUMENTAL",
      videoId: "3r9Z87Mc3JA", 
    },
    {
      description: "¿Qué hay detrás del Colectivo DLR? El Hacktivismo, La Violencia Digital y Las Victimas",
      videoId: "7MS9Gl6xjEw", 
    },
    {
      description: "Explicación sobre la violencia de género y sus implicaciones.",
      videoId: "iR5xRlaExqM", 
    },
    {
      description: "Análisis de la violencia de género en el ámbito digital.",
      videoId: "e4X6ACJ_NfI",
    },
  ];

  return (
    <div id="Videos" className="w-full bg-[#f4f4f4]">
      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-4">
        {videos.map((video, index) => (
          <div key={index}>
            <VideoCard {...video} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoSection;